module.exports = __webpack_public_path__ + "27b7380ac903d5c23f23f63ad63222de.pdf";